// ── Status map ───────────────────────────────────────────────────────────────

export const STATUS_MAP = {
  PENDING: {
    label: 'รอดำเนินการ',
    short: 'รอดำเนินการ',
    color: '#64748b',
    bg: '#f1f5f9',
  },
  IN_PROGRESS: {
    label: 'กำลังดำเนินการ',
    short: 'ดำเนินการ',
    color: '#2563eb',
    bg: '#eff6ff',
  },
  DELIVERY: {
    label: 'งาน100%รอรับเงินงวดสุดท้าย',
    short: 'รอรับเงิน',
    color: '#d97706',
    bg: '#fffbeb',
  },
  Warranty: {
    label: 'มีWarrant/Guarantee',
    short: 'Warranty',
    color: '#7c3aed',
    bg: '#f5f3ff',
  },
  WAITING_PAYMENT: {
    label: 'รอรับชำระเงิน',
    short: 'รอชำระ',
    color: '#c2410c',
    bg: '#fff7ed',
  },
  ELIGIBLE_FOR_CLOSE: {
    label: 'พร้อมปิดงาน',
    short: 'พร้อมปิด',
    color: '#0369a1',
    bg: '#e0f2fe',
  },
  COMPLETED: {
    label: 'ไม่มีภาระผูกพัน',
    short: 'ปิดงาน',
    color: '#059669',
    bg: '#ecfdf5',
  },
};
export const STATUS_KEYS = Object.keys(STATUS_MAP);

// ── operation_status → dash_* fields mapping ─────────────────────────────────
// เมื่อเปลี่ยน col 2 → auto-fill สถานภาพภายในโครงการ
// dash_commitment คำนวณ auto จาก computeCommitment() ไม่ต้องระบุ
export const STATUS_TO_DASH = {
  PENDING: {
    dash_work: '',
    dash_delivery: 'none',
    dash_disbursement: 'none',
    dash_warranty: 'none',
    dash_billing: 'none',
    dash_payment: 'waiting',
  },
  IN_PROGRESS: {
    dash_work: '',
    dash_delivery: 'partial',
    dash_disbursement: 'has',
    dash_warranty: 'none',
    dash_billing: 'none',
    dash_payment: 'waiting',
  },
  DELIVERY: {
    dash_work: 'done',
    dash_delivery: 'done',
    dash_disbursement: 'has',
    dash_warranty: 'none',
    dash_billing: 'partial',
    dash_payment: 'waiting',
  },
  Warranty: {
    dash_work: 'done',
    dash_delivery: 'done',
    dash_disbursement: 'none',
    dash_warranty: 'warranty',
    dash_billing: 'done',
    dash_payment: 'partial',
  },
  WAITING_PAYMENT: {
    dash_work: 'done',
    dash_delivery: 'done',
    dash_disbursement: 'none',
    dash_warranty: 'none',
    dash_billing: 'done',
    dash_payment: 'waiting',
  },
  ELIGIBLE_FOR_CLOSE: {
    dash_work: 'done',
    dash_delivery: 'done',
    dash_disbursement: 'none',
    dash_warranty: 'expired',
    dash_billing: 'done',
    dash_payment: 'received',
  },
  COMPLETED: {
    dash_work: 'done',
    dash_delivery: 'done',
    dash_disbursement: 'none',
    dash_warranty: 'none',
    dash_billing: 'done',
    dash_payment: 'received',
  },
};

// ── 3-Dimension Status System ─────────────────────────────────────────────────

export const WORK_OPTIONS = [
  { key: 'waiting', label: 'รอเข้าดำเนินการ', color: '#64748b' },
  { key: 'in_progress', label: 'ดำเนินการ', color: '#2563eb' },
  { key: 'done', label: 'เสร็จ 100%', color: '#059669' },
];

// วิธีดำเนินการ — มีความหมายเฉพาะตอน work_status==='in_progress' เท่านั้น (field แยกต่างหาก
// ไม่ได้แทนที่ 'in_progress' เพื่อไม่กระทบ exact-match เดิมของ work_status ที่มีอยู่หลายจุด)
export const WORK_METHOD_OPTIONS = [
  { key: 'self', label: 'ดำเนินการ (ทำเอง)', shortLabel: 'ทำเอง', color: '#2563eb' },
  { key: 'hired', label: 'ดำเนินการ (จ้างเหมา)', shortLabel: 'จ้างเหมา', color: '#2563eb' },
  { key: 'mixed', label: 'ดำเนินการ (ทำเอง+จ้าง)', shortLabel: 'ทำเอง+จ้าง', color: '#2563eb' },
];

export const FINANCE_OPTIONS = [
  { key: 'none', label: 'ยังไม่เคยเบิก', color: '#94a3b8' },
  { key: 'partial', label: 'เบิกแล้วบางส่วน', color: '#f59e0b' },
  { key: 'billed_waiting', label: 'วางบิลแล้วรอรับเงิน', color: '#d97706' },
  { key: 'last_installment', label: 'รอรับงวดสุดท้าย', color: '#c2410c' },
  { key: 'completed_po', label: 'รับเงิน100%แล้ว', color: '#059669' },
];

export const BG_USAGE_OPTIONS = [
  { key: 'no_bg_usage', label: 'ไม่ใช้ BG แล้ว', color: '#059669' },
];
export const NO_BG_USAGE_KEY = 'no_bg_usage';

export const LEGAL_OPTIONS = [
  { key: 'legal_warranty', label: 'Warrant/Guarantee', labelEn: 'Warrant/Guarantee', color: '#7c3aed' },
  { key: 'legal_debt', label: 'เจ้าหนี้ค้างจ่าย', labelEn: 'Overdue Payable', color: '#dc2626' },
  { key: 'legal_lawsuit', label: 'ฟ้องร้อง', labelEn: 'Lawsuit', color: '#991b1b' },
];

// สถานะรายงาน/เอกสารส่งงาน — default '' = ยังไม่ได้ระบุ (ต้องแสดงเตือนสีแดง จนกว่า user จะเลือก
// อย่างใดอย่างหนึ่งข้างล่างนี้ รวมถึง 'none' ที่แปลว่า "ไม่มีรายงานต้องส่ง" ก็ถือว่าตัดสินใจแล้ว)
export const REPORT_OPTIONS = [
  { key: 'none', label: 'ไม่มีรายงานต้องส่ง', color: '#2563eb' },
  { key: 'pending', label: 'ต้องส่งรายงาน (ยังไม่ส่ง)', color: '#dc2626' },
  { key: 'submitted', label: 'ต้องส่งรายงาน (ส่งแล้ว)', color: '#059669' },
];

export const FILTER_META = {
  has_commitment: { label: 'มีภาระผูกพัน', labelEn: 'Has Commitment', color: '#d97706' },
  no_commitment: { label: 'ไม่มีภาระผูกพัน', labelEn: 'No Commitment', color: '#059669' },
  col9_positive: { label: 'JS · มีภาระ · col9>0', labelEn: 'JS · Has Commitment · col9>0', color: '#2563eb' },
  col7_positive: { label: 'JS · มีภาระ · col7>0', labelEn: 'JS · Has Commitment · col7>0', color: '#059669' },
  col9_or_col7_nonzero: {
    label: 'JS · มีภาระ · col9≠0 | col7≠0',
    labelEn: 'JS · Has Commitment · col9≠0 | col7≠0',
    color: '#7c3aed',
  },
  ...Object.fromEntries(
    WORK_OPTIONS.map((o) => [
      `work_${o.key}`,
      { label: `งาน: ${o.label}`, color: o.color },
    ]),
  ),
  ...Object.fromEntries(
    FINANCE_OPTIONS.map((o) => [
      `finance_${o.key}`,
      { label: `การเงิน: ${o.label}`, color: o.color },
    ]),
  ),
  ...Object.fromEntries(
    BG_USAGE_OPTIONS.map((o) => [
      `bg_${o.key}`,
      { label: `งบ: ${o.label}`, color: o.color },
    ]),
  ),
  ...Object.fromEntries(
    LEGAL_OPTIONS.map((o) => [
      o.key,
      { label: o.label, labelEn: o.labelEn, color: o.color },
    ]),
  ),
};

// ป้ายกำกับสำหรับชิป "ไม่รวมแถวที่ค่า=0/ว่าง" — ใช้เฉพาะคอลัมน์ตัวเลข/วันที่ที่มีสูตรเดี่ยวชัดเจน
// (ดู getFieldValue ใน ProjectDashboardTable.js) คอลัมน์ข้อความ/สถานะผสม (โครงการ/ผู้ว่าจ้าง/สถานะ/
// หมายเหตุ/ตรวจสอบ) ไม่รวมอยู่ในนี้ — export มาไว้ที่นี่เพื่อให้ ProjectList.js ใช้ label ชุดเดียวกัน
// ตอน render chip ได้ (ย้ายชิป manual filter ทั้งหมดไปแสดงที่แถบบนสุดแทนแล้ว)
export const ZERO_EXCLUDE_LABELS = {
  progress: '% ความคืบหน้า',
  po: '1 PO',
  billed_waiting: '2 Invoiced [VAT incl]',
  received: '3 รับเงินมาแล้ว',
  po_remaining: '4 ยอดค้างส่งงานจาก PO',
  target_profit: '5 Profit Target',
  total_budget: '6 BG ที่ตั้งไว้',
  total_expenses: '7 BG PAID',
  projected_fund: '8 BG Remain now',
  expected_value: '9 รายการตั้งเบิกที่รอจ่าย',
  ap_pending_unpaid: '10 AP PENDING ตามงบย่อย',
  to_spend: '11 ต้องใช้อีก',
  col12_payable_bg_eligible: '12 BGเหลือที่มีสิทธิจ่าย',
  refund_pending: '13 รอเงินคืน',
  col17: '14 สรุปอนาคตต้องจ่ายอีกรวม',
  delivery_date: '15 ส่งงานวันที่',
  credit_days: '16 เครดิต (วัน)',
  payment_cycle_day: '17 รอบจ่ายเงิน',
  expected_date: '18 รับเงินวันที่',
  days_left: '19 รับเงินอีก(วัน)',
  net_remaining: '20 สรุป BG คงเหลือ',
  over_budget: '21 สรุป BG เกิน',
  realprofit: '22 สรุปกำไรคาดการณ์',
  profit_pct: '% กำไร',
  bg_used_pct: '%ใช้ BG',
  oldest_job_month: 'Mo',
  oldest_job_year: 'Yr',
};

// ── Column header ─────────────────────────────────────────────────────────────

export const TH_SX = {
  bgcolor: '#bae6fd',
  color: '#1e3a5f',
  fontWeight: 600,
  fontSize: '0.775rem',
  lineHeight: 1.15,
  letterSpacing: '0.01em',
  textAlign: 'center',
  py: 0.5,
  px: 1,
  borderRight: '1px solid rgba(30,58,95,0.1)',
  borderBottom: '2px solid rgba(30,58,95,0.18)',
  position: 'sticky',
  top: 0,
  zIndex: 2,
  verticalAlign: 'top',
  cursor: 'default',
  overflow: 'hidden',
};

export const TH_HAS_TOT = { verticalAlign: 'top', pb: '22px' };

export const TH_GROUP_SX = {
  ...TH_SX,
  borderTop: '6px solid #0d3d39',
};

export const TH_GROUP2_SX = {
  ...TH_SX,
  borderTop: '6px solid #ef4444',
};

export const TH_GROUP3_SX = {
  ...TH_SX,
  borderTop: '6px solid #713f12',
};

export const TH_GROUP4_SX = {
  ...TH_SX,
  borderTop: '6px solid #10b981',
};

export const TH_GROUP5_SX = {
  ...TH_SX,
  borderTop: '6px solid #a855f7',
};

export const TD_SX = {
  py: 0.7,
  px: 1,
  borderRight: '1px solid rgba(203,213,225,0.5)',
  borderBottom: '1px solid rgba(203,213,225,0.4)',
  verticalAlign: 'middle',
  overflow: 'hidden', // กันตัวเลข/ข้อความล้นทะลุไปทับคอลัมน์ถัดไปเวลาช่องแคบกว่าเนื้อหา (ของเดิมไม่มี ปล่อยล้นได้)
};

// ── Column defaults ───────────────────────────────────────────────────────────

// ความกว้าง fix สำหรับคอลัมน์ตัวเลข (บาท) ทุกช่อง — พอสำหรับ "-100,000,000.00" เสมอ ไม่ต้องคำนวณสดจากข้อมูล
export const MONEY_COL_WIDTH = 168;

// ความกว้างคอลัมน์ Excel export — คัดลอกมาจากไฟล์ตัวอย่างที่ผู้ใช้ปรับความกว้างไว้เอง
// (project_dashboard_2026-07-24 rev by kpp.xlsx) เรียงตามลำดับ 34 คอลัมน์ที่ handleExportExcel สร้าง
export const REFERENCE_COL_WIDTHS = [
  7.75, 24.63, 17.25, 15.75, 9.5, 12.88, 9.5, 15.13, 38.38, 37.88, 12.13, 12.5,
  13.5, 14.38, 12.75, 12.63, 13.25, 15.75, 14.88, 12.13, 15.38, 14.88, 10.5,
  11.75, 11.38, 14.13, 11.25, 13.75, 17.13, 13.88, 13.63, 10.13, 9.13, 36.13,
];

export const COL_DEFAULTS = {
  1: 68,
  2: 160,
  3: 44,
  4: 250,
  5: 250,
  6: MONEY_COL_WIDTH,
  7: MONEY_COL_WIDTH,
  8: MONEY_COL_WIDTH,
  9: MONEY_COL_WIDTH,
  18: MONEY_COL_WIDTH,
  27: 88,
  28: 70,
  31: 76,
  29: 88,
  30: 78,
  10: MONEY_COL_WIDTH,
  33: MONEY_COL_WIDTH,
  11: MONEY_COL_WIDTH,
  12: MONEY_COL_WIDTH,
  35: MONEY_COL_WIDTH,
  32: MONEY_COL_WIDTH,
  13: 70,
  14: MONEY_COL_WIDTH,
  15: MONEY_COL_WIDTH,
  34: MONEY_COL_WIDTH,
  16: MONEY_COL_WIDTH,
  17: MONEY_COL_WIDTH,
  19: MONEY_COL_WIDTH,
  20: 70,
  26: 110,
  36: 80,
  37: 36,
  38: 36,
};

export const ALL_WORK_KEYS = ['', 'waiting', 'in_progress', 'done'];
export const ALL_FINANCE_KEYS = [
  '',
  'none',
  'partial',
  'billed_waiting',
  'last_installment',
  'completed_po',
];
export const DIM3_FILTER_DEFAULT = {
  work: Object.fromEntries(ALL_WORK_KEYS.map((k) => [k, true])),
  finance: Object.fromEntries(ALL_FINANCE_KEYS.map((k) => [k, true])),
  legal_warranty: true,
  legal_debt: true,
  legal_lawsuit: true,
};
